// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3_mcL","title":"Header_title__2zqD8","side":"Header_side__2b4ga"};